import { makeStyles } from "@material-ui/styles";

const seasonSettingsStyles = makeStyles(() => ({
	secondaryActionContainer: {
		display: "flex",
		alignItems: "flex-end",
		gap: 5
	}
}));

export default seasonSettingsStyles;
